module.exports = __webpack_public_path__ + "files/3a9a5a456f1076b42202c7fb0c316ac7.png";